import { useEffect, useState } from "react";
import _ from "lodash";
import LineUp from "../assets/LineUp.svg";
import Image from "../../../Image";
import { getTemplateById } from "../../../../../../services/backend/api.service";
import { Button, Dropdown, Space } from "antd";
import { CheckOutlined, DownOutlined } from "@ant-design/icons";
import { useGlobalStore } from "../../../../../../stores/globalBackendStore";

// are not normal templates
export const filteredTemplates = ["fcb_lineup", "fcb_matchday_2"];

function TemplatesTab({
  templateData,
  setTemplateData,
  selectedTemplate,
  setSelectedTemplate,
  setReservedPlayers,
  setSelectedPlayers,
  originTemplateData
}) {
  // 

  const [selectedLanguage, setSelectedLanguage] = useState("english");
  const apiSetup = useGlobalStore((state) => state.apiSetup);
  const templates = apiSetup?.templates?.sort((a, b) =>
    a.label.toLowerCase().localeCompare(b.label.toLowerCase()),
  )?.filter(template => template.name === templateData.template_name)
  const items = [
    {
      label: "English",
      key: "english",
    },
    {
      label: "German",
      key: "german",
    },
    {
      label: "Portuguese",
      key: "portuguese",
    },
    {
      label: "Deutsch",
      key: "deutsch",
    },
  ];

  const handleMenuClick = (e) => {
    setSelectedLanguage(e.key);
  };
  const menuProps = {
    items,
    onClick: handleMenuClick,
  };

  function extractSelectedPlayers(dataArray, fieldId) {
    const field = dataArray.find((item) => item.id === fieldId);

    if (!field || !Array.isArray(field.data) || !Array.isArray(field.value)) {
      return [];
    }

    return field.data
      .filter((player) => field.value.includes(player.id))
      .map((player) => ({
        id: player.id,
        shirtNumber: player.shirtNumber,
        shortFirstName: player.shortFirstName,
        shortLastName: player.shortLastName,
      }));
  }

  const onTemplateSelect = (e, { id, template_name }) => {
    if (selectedTemplate === template_name) {
      // Deselect if already selected
      setSelectedTemplate("");
      const newTempData = _.cloneDeep(originTemplateData);
      const prevBackgrounds = _.get(templateData, "data.fields[0]", {});
      _.set(newTempData, "data.fields[0]", prevBackgrounds);
      setTemplateData({
        ...newTempData,
        selectFromTemplates: true,
      });
      setSelectedPlayers([]);
      setReservedPlayers([]);
      return;
    }
    setSelectedTemplate(template_name);

    getTemplateById({ id, template_name }).then((data) => {
      const apiData = _.get(data, "data", {});
      if (templateData) {
        // need to preserve images
        const newTempData = _.cloneDeep(apiData);
        const prevBackgrounds = _.get(templateData, "data.fields[0]", {});
        const prevEvent = _.get(templateData, "event", {});
        const prevLang = _.get(templateData, "lang", null);
        const prevDynamicData = _.get(templateData, "data.dynamic", {});
        const prevUpdater = _.get(templateData, "data.updater", {});
        _.set(newTempData, "data.fields[0]", prevBackgrounds);
        _.set(newTempData, "event", prevEvent);
        _.set(newTempData, "lang", prevLang);
        _.set(newTempData, "data.dynamic", prevDynamicData);
        _.set(newTempData, "data.updater", prevUpdater);

        const index = templateData.data.fields.findIndex(f => f.id === 'heatmap_players');
        const prevHeatmapPlayer = _.get(templateData, `data.fields[${index}].value`, null);
        if (index !== -1) {
          _.set(newTempData, `data.fields[${index}].value`, prevHeatmapPlayer);
        }

        // if the same template is selected, don't need to update uuid
        if (originTemplateData.template_name === apiData.template_name) {
          const prevUuid = _.get(originTemplateData, "uuid", 0);
          _.set(newTempData, "uuid", prevUuid);
        }
        setTemplateData({
          ...newTempData,
          selectFromTemplates: true,
        });
        // }

      } else {
        setTemplateData(apiData);
      }
    });
  };

  useEffect(() => {
    if (templateData) {
      const fields = templateData?.data?.fields || [];

      const selectedPlayers = extractSelectedPlayers(fields, "lineup_players");
      const reservedPlayers = extractSelectedPlayers(fields, "reserve_players");

      setSelectedPlayers(selectedPlayers);
      setReservedPlayers(reservedPlayers);
    }
  }, [selectedTemplate, templateData]);

  return (
    <div className="templates-tab">
      <div className="section">
        {/* <h4 className="editor-sidebar-title">Content Languages</h4>
        <Dropdown menu={menuProps}>
          <Button className="language-selector-div">
            <Space className="language-selector">
              {items.find((item) => item.key === selectedLanguage)?.label ||
                "Select Language"}
              <DownOutlined />
            </Space>
          </Button>
        </Dropdown> */}

        <h4 className="editor-sidebar-title">Recommended Templates</h4>
        <div className="template-grid">
          {templates?.length > 0 ? (
            templates?.map((t) => (
              <div
                key={t?.name}
                className="template-card"
                onClick={() => {
                  onTemplateSelect(null, {
                    id: 0,
                    template_name: t?.name,
                  });
                }}
              >
                <div className="image-wrapper">
                  <Image src={LineUp} className="template-image" />
                  {selectedTemplate === t?.name && (
                    <div className="overlay">
                      <span className="tick">
                        <CheckOutlined />
                      </span>
                    </div>
                  )}
                </div>
                <span>{t?.label}</span>
              </div>
            ))
          ) : (
            <p className="empty-text">No templates found</p>
          )}
        </div>
      </div>

      <div className="section">
        <h4 className="editor-sidebar-title">Saved Templates</h4>
      </div>
    </div>
  );
}

export default TemplatesTab;
